/** @jsxImportSource @emotion/react */
import tw from 'twin.macro';
import { css } from '@emotion/react';

import { ReactComponent as CloseSVG } from 'assets/Icons/speaker-remove.svg';
import { hoverDropShadow } from 'components/shared/twin.styles';
import { Hint } from 'components/shared/Hint';
import { useDispatch } from 'react-redux';
import { removeSearchTextBox } from 'slices/advanced-search.slice';
import { AdvancedFilterType } from 'utils/enum';
import { removeCollectionFilter } from 'slices/collection.slice';

type FilterBoxItemsProps = {
  typeEnum: AdvancedFilterType;
  text: string;
  readOnly?: boolean;
};

export const FilterTextBox = (props: FilterBoxItemsProps) => {
  const dispatch = useDispatch();

  const handleRemove = () => {
    const payload = {
      type: props?.typeEnum,
      text: props?.text,
    };

    if (props?.typeEnum === AdvancedFilterType.COLLECTION) {
      dispatch(removeCollectionFilter(props?.text));
    } else {
      dispatch(removeSearchTextBox(payload));
    }
  };

  return (
    <div
      css={[
        tw`flex mt-1.5 max-width[25rem] rounded-xl pl-1.5 pr-1.5`,
        props.readOnly
          ? tw`items-center bg-sonnant-grey-5 opacity-[0.4] cursor-default select-none rounded-[0.25rem]`
          : tw`justify-between border-sonnant-blue border-width[2px] border-solid`,
      ]}
    >
      <div
        className="line-clamp-1"
        css={[
          tw`text-12 font-medium word-break[break-all]`,
          props.readOnly
            ? tw`font-normal text-[#fefefe]`
            : tw`mr-2`,
        ]}
      >
        {props?.text}
      </div>

      {!props.readOnly && (
        <span tw="mr-0.5">
          <Hint text="Remove" notTransparent arrow>
            <CloseSVG
              css={[hoverDropShadow(0.4), xIconCss]}
              onClick={handleRemove}
            />
          </Hint>
        </span>
      )}
    </div>
  );
};

const xIconCss = css`
  ${tw`relative top[1px]`}

  &:hover path {
    ${tw`fill[blue]`}
  }
`;
